















































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ConservatorshipDetails } from '@/modules/conservatorship/types';
import {
  PropertyUsage,
  ReportFinances,
  ReportOfConservatorshipManagement
} from '@/modules/reportOfConservatorshipManagement/types';
import uuid from 'uuid/v4';
import clone from 'clone';

@Component({})
export default class Stepper6 extends Vue {
  @Prop({ type: Object, required: true }) conservatorship!: ConservatorshipDetails;
  @Prop({ type: Object, required: true }) report!: ReportOfConservatorshipManagement;
  @Prop({ type: Object }) finances?: ReportFinances;
  @Prop({ type: String }) date!: string;

  dateChanged = false;

  @Watch('date')
  onDate(date: string) {
    this.dateChanged = true;
  }

  @Watch('finances', { immediate: true })
  onFinances(finances?: ReportFinances) {
    if (!finances) {
      return;
    }

    if (this.report.economic_circumstances.end_balance.finance_accounts.length === 0 || this.dateChanged) {
      this.syncAccounts(finances);
    }
    if (this.report.economic_circumstances.end_balance.properties.length === 0 || this.dateChanged) {
      this.syncProperties(finances);
    }

    this.dateChanged = false;
  }

  syncProperties(finances: ReportFinances) {
    this.report.economic_circumstances.end_balance.properties = finances.assets
      .filter((asset) => {
        return asset.type === 'property';
      })
      .map((asset) => ({
        id: asset.id,
        name: asset.name,
        balance: asset.balance,
        boundary: '',
        bl: '',
        bd: '',
        usage: 'owner_occupation' as PropertyUsage
      }));
  }

  syncAccounts(finances: ReportFinances) {
    const order: { [type: string]: number } = { cash_account: 0, bank_account: 1, credit_account: 2 };

    this.report.economic_circumstances.end_balance.payables.amount = parseFloat(finances.payables);
    this.report.economic_circumstances.end_balance.finance_accounts = clone(finances.accounts, false)
      .sort((first, second) => {
        return order[first.category] - order[second.category];
      })
      .map((account) => ({
        ...account,
        balance: parseFloat(account.balance)
      }));
  }

  removeProperty({ id }: { id: string }) {
    this.report.economic_circumstances.end_balance.properties = [
      ...this.report.economic_circumstances.end_balance.properties.filter((payable) => payable.id !== id)
    ];
  }

  addProperty() {
    this.report.economic_circumstances.end_balance.properties = [
      ...this.report.economic_circumstances.end_balance.properties,
      { id: uuid(), name: '', balance: 0, boundary: '', bl: '', bd: '', usage: 'owner_occupation' as PropertyUsage }
    ];
  }

  removeAccount({ id }: { id: string }) {
    this.report.economic_circumstances.end_balance.finance_accounts = [
      ...this.report.economic_circumstances.end_balance.finance_accounts.filter((payable) => payable.id !== id)
    ];
  }

  addAccount() {
    this.report.economic_circumstances.end_balance.finance_accounts = [
      ...this.report.economic_circumstances.end_balance.finance_accounts,
      { id: uuid(), name: '', balance: 0, number: '', category: 'cash_account' }
    ];
  }
}
